import { fetchGetApiIntroducerPortalIntroducerApplications } from '@iwoca/lapi-client/introducer_portal';
import { useQuery } from '@tanstack/react-query';
import { generateDateMonthsPrevious } from 'components/Dashboard/Dashboard.context.helpers';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';

const DEFAULT_APPLICATION_MONTHS_FILTER_VALUE = 1;

const buildApplicationsQuery = (
  search?: string,
  dateFrom?: string | null,
  includePartnerChannel?: boolean,
) => {
  const query: {
    search?: string;
    date_from?: string;
    include_partner_channel?: boolean;
  } = {};

  if (search) {
    query.search = search;
  } else if (dateFrom !== null) {
    query.date_from =
      dateFrom ||
      generateDateMonthsPrevious(DEFAULT_APPLICATION_MONTHS_FILTER_VALUE) ||
      undefined;
  }

  if (includePartnerChannel) {
    query.include_partner_channel = includePartnerChannel;
  }

  return query;
};

export const useGetApplications = (
  search?: string,
  dateFrom?: string | null,
  includePartnerChannel?: boolean,
) => {
  const { introducerId } = useIntroducerData();
  return useQuery({
    queryKey: [
      'applications',
      introducerId,
      dateFrom,
      search,
      includePartnerChannel,
    ],
    queryFn: () =>
      fetchGetApiIntroducerPortalIntroducerApplications({
        introducerId: introducerId as string,
        query: buildApplicationsQuery(search, dateFrom, includePartnerChannel),
      }),
    enabled: !!introducerId,
  });
};
